module.exports = __webpack_public_path__ + "media/images/flags/32/Jamaica-901c6df2e01cc613f58ecbd4a7e1ef52.png";